import React, { useCallback } from "react"
import PropTypes from "prop-types"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import Button from "../ui/button/Button"
import { scrollToId } from "../../helpers/helpers"
import Container from "../../hoc/container/Container"

import chatIcon from "../../assets/icons/chat.svg"
import logoImg from "../../assets/brand/logo-type.svg"

import style from "./Nav.module.css"

const Nav = ({}) => {
  return (
    <nav className={style.container}>
      <Container large={true}>
        <img src={logoImg} alt="Agaia Logo" className={style.logo} />

        <AniLink to="/" className={style.link} swipe direction="down">
          <img src={chatIcon} alt="Chat" />
          <span>Chat to Agaia</span>
        </AniLink>
      </Container>
    </nav>
  )
}

Nav.propTypes = {}
Nav.defaultProps = {}

export default Nav
